// react core
import React from 'react';
import TimeAgo from 'react-timeago'
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";

// components
import AuthorLink from 'components/commons/author_link';
import TagLink from 'components/commons/tag_link';

// confs
import conf from 'conf/ajax';

export default function QuestionSummary(props)
{
    const item = props.item;
    const highlight_on = props.highlight === true;
    let question_class = 'wall-item question-preview'
    const is_approved = props.item.approved === true
    const has_activity = props.item.has_activity === true
    const is_closed = props.item.is_open === false
    const extra_details = props.extra_details

    if (is_approved) {
        question_class = question_class + ' question-preview-approved'
    }

    return (
        <div className={question_class} id={item.id} key={item.id}>
            <div>
                <div className="question-preview-header">
                <Link to={`${conf.route.answer}${item.id}`}>
                        <h3>
                            { (highlight_on)
                            ? <Highlighter
                                highlightClassName="finded"
                                searchWords={props.searched_text.split(' ')}
                                autoEscape={true}
                                textToHighlight={item.title}
                            />
                            : <span>{item.title}</span>
                            }
                        </h3>
                    </Link>
                </div>

                <div className="question-preview-body">
                    <p className="description">{item.description}</p>
                </div>

                <div className="question-preview-footer">
                    <div>
                        <span>Asked by <AuthorLink author={item.author} /> <TimeAgo date={item.added_at} minPeriod="60" /> in
                        {item.tags !== null && item.tags.map(tag => (
                            <span key={tag.id}> <TagLink  tag={tag}/> </span>
                        ))}</span>

                    </div>

                    <div>
                    { has_activity === true &&
                    <span>Last activity by  <AuthorLink author={item.last_activity.by} /> <TimeAgo date={item.last_activity.at} minPeriod="60" /> ({item.last_activity.what})</span>
                    }

                    { is_approved === true &&
                    <span>Answer by <AuthorLink author={item.approved_answer_user} /> was approved <i className="fa-solid fa-award"></i></span>
                    }
                    </div>

                    { is_closed === true &&
                    <div>
                        <span>
                            <i className="fa-solid fa-lock"></i> Closed <TimeAgo date={item.closed_at} minPeriod="60" />
                            { item.message &&
                                <>&nbsp;&mdash; <em>{item.message}</em></>
                            }
                        </span>
                    </div>
                    }

                    { extra_details &&
                        <div className="question-preview-footer-extra">{extra_details}</div>
                    }
                </div>

            </div>
            <div>
                <div className="question-votes">
                    <span>Score:</span> <span>{item.vote_count}</span>
                </div>
                <div className="question-answers">
                    <span>Answers:</span> <span>{item.subs}</span>
                </div>
                <div className="question-comments">
                    <span>Comments:</span> <span>{item.comment_count}</span>
                </div>
                <div className="question-views">
                    <span>Views:</span> <span>{item.view_count}</span>
                </div>
            </div>

        </div>
    );
};

QuestionSummary.defaultProps = {
    searched_text: '',
    highlight: false,
    current_tag: null
  };